import type { ReactNode } from 'react'
import { MsalProvider } from '@azure/msal-react'
import { pca } from './msalConfig'

export function AuthProvider({ children }: { children: ReactNode }) {
  return <MsalProvider instance={pca}>{children}</MsalProvider>
}
